import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {FormDataUpload, NestApiProvider} from '../../nest-api';

@Injectable()
export class ProcessTemplateProvider {

  private readonly _service: string = 'payroll';
  private readonly _model: string = 'processtemplate';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public employeeDataMaster(file): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'employeeDataMasterNoQueue';
    const _params: FormDataUpload[] = [];
    _params.push({name: 'file', value: file});
    const _urlParams: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestUpload(_method, _url, _params);
  }

  public uploadtemptax(file): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'taxDataUploadNoQueue';
    const _params: FormDataUpload[] = [];
    _params.push({ name: 'file', value: file });
    const _urlParams: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestUpload(_method, _url, _params);
}

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/process-template/process-template.ts